<template>
  <pack>
    <zt-title>{{title}}</zt-title>
    <zt-input placeholder="请在这里输入标题" v-model="articleData.title"></zt-input>
    <ZtEditor
      v-model="articleData.content"
      placeholder="请输入文章内容">
    </ZtEditor>
    <div class="btn">
      <zt-button type="primary" @click="save">保存</zt-button>
      <zt-button @click="close">关闭</zt-button>
    </div>
  </pack>
</template>

<script>
import {
  admin_help_article_add,
  admin_help_article_view,
  admin_help_article_edit
} from '@/api/helpManage';
import ZtEditor from '@/components/ZtEditor/ZtEditor';

export default {
  components: {
    ZtEditor,
  },
  data: () => ({
    firstChange: true,
    title: '添加文章',
    defaultContent: '',
    articleData: {
      content: '',
      title: '',
      ls_id: '',
      id: '',
    },
  }),
  watch: {
  },
  computed: {
    isAdd: (vm) => vm.$route.params.id.split('_')[1] == 'add',
  },
  methods: {
    //返回
    close() {
      this.$confirm('当前内容还未保存，确定退出吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        this.$router.push('/helpManage');
      });
    },

    //保存
    async save() {
      if (this.articleData.title == '') {
        return this.$message.error('请输入标题');
      }
      if (this.articleData.content == '') {
        return this.$message.error('请输入文章内容');
      }
      const { data } = await this.getApi(this.articleData);
      if (data.error_code == 0) {
        this.$message.success(
          `${this.isAdd ? '新增文章成功' : '修改文章成功'}`
        );
        this.$router.push('/helpManage');
      }
    },

    async getApi(params) {
      const data = this.isAdd
        ? await admin_help_article_add(params)
        : await admin_help_article_edit(params);
      return data;
    },

    //加载文章内容
    async getArticleDetail() {
      const { data } = await admin_help_article_view({
        id: this.articleData.id,
      });
      this.articleData = data.info;
      this.defaultContent = data.info.content;
    },
  },
  beforeRouteEnter(to, form, next) {
    to.meta.title = to.params.id.split('_')[2] || '添加文章';
    next();
  },
  destroyed() {},
  mounted() {
    const { params } = this.$route;
    this.articleData.ls_id = params.id.split('_')[0];
    //新增文章
    if (this.isAdd) {
      this.title = '添加文章';
    } else {
      this.articleData.id = params.id.split('_')[1];
      this.title = '修改文章';
      this.getArticleDetail();
    }
  },
};
</script>

<style lang="scss" scoped>
/deep/ .zt-title {
  margin-bottom: 14px;
}
/deep/ .ql-container {
  min-height: 300px;
  max-height: 500px;
  overflow: auto;
}
/* 滚动条样式 */
/deep/ ::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
/deep/ ::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background: #d8d8d8;
}
/deep/ ::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 10px;
  background: #f9f9f9;
}
.btn {
  float: right;
  margin-top: 16px;
  /deep/ .el-button--primary {
    margin-right: 20px;
  }
  /deep/ .el-button {
    width: 143px;
    border-radius: 2px;
  }
}
/deep/ .zt-input {
  width: 300px;
  margin-bottom: 20px;
}
</style>
